import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';

const cls = classNames('humantix-embed');
const HUMANITIX_COLLECTIONS_URL = 'https://collections.humanitix.com';
const HUMANITIX_IFRAME_ALLOW = "payment; clipboard-write 'src';";

// -------- Types -------->

// -------- Props -------->

export type HumantixEmbedProps = Classable & HasChildren & {
  collection?: string;
}

export const HumantixEmbedDefaultProps: HumantixEmbedProps = {
  collection: 'town-team-movement-events',
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

const IframeStyles = breakpoints({
  base: css`
    border: none;
    max-height: 0;
    min-height: 0;
    min-width: 100%;
    width: 100%;
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Iframe: styled.iframe`${IframeStyles}`,
};

export const HumantixEmbed: Shapeable.FC<HumantixEmbedProps> = (props) => {
  const { className, collection } = props;
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  const src = `${HUMANITIX_COLLECTIONS_URL}/${collection}?widget=collection`;

  React.useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const iframe = iframeRef.current;

      if (!iframe || iframe.contentWindow !== event.source) {
        return;
      }

      const { type, payload } = event.data || {};

      switch (type) {
        case 'HX_WIDGETS_V2_INLINE_HEIGHT':
          iframe.style.minHeight = `${(payload?.pageHeight || 0) + 1}px`;
          iframe.style.maxHeight = '';
          break;
        case 'HX_WIDGETS_V2_SCROLL_TO_TOP':
          iframe.scrollIntoView({ behavior: 'auto', block: 'start' });
          break;
        case 'HX_WIDGETS_V2_SCROLL_TO_Y': {
          const y = payload?.y || 0;
          const top = iframe.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: top + y, behavior: 'smooth' });
          break;
        }
        case 'HX_WIDGETS_V2_REDIRECT_HOST_PAGE':
          if (payload?.redirectUrl) {
            window.location.href = payload.redirectUrl;
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <My.Container className={cls.name(className)}>
      <My.Iframe
        allow={HUMANITIX_IFRAME_ALLOW}
        data-collection={collection}
        ref={iframeRef}
        src={src}
        title="Humanitix events"
      />
    </My.Container>
  )
};

HumantixEmbed.defaultProps = HumantixEmbedDefaultProps;
HumantixEmbed.cls = cls;